<div class="user-message-dialog" [ngClass]="'user-message-dialog--'+severity" [dir]="isRTL ? 'rtl' : 'ltr'">
  <div class="user-message-dialog__symbol"><i class="fas" [ngClass]="icon" aria-hidden="true"></i></div>
  <h2 id="user-message-dialog-title">{{ title }}</h2>
  <div id="user-message-dialog-description" class="user-message-dialog__description"><p *ngIf="message">{{ message }}</p><p *ngIf="detail">{{ detail }}</p></div>
  <div class="user-message-dialog__actions">
    <button type="button" class="btn btn-outline-secondary" ngbAutofocus [disabled]="busy" (click)="activeModal.dismiss('cancel')">{{ cancelLabel }}</button>
    <button type="button" class="btn" [ngClass]="destructive ? 'user-message-danger' : 'btn-primary'" [disabled]="busy" (click)="activeModal.close('confirm')">{{ confirmLabel }}</button>
  </div>
</div>
